import React from 'react';

const Page = React.lazy(() => import('./OutstandingInvoicesReportPage'));

const OutstandingInvoicesReportConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports/outstanding-invoices',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Page />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default OutstandingInvoicesReportConfig;
